import type { SessionHandle } from './types';

// Session handling (AC-B-025, frontend-handoff 11).
// The raw invite token is NEVER stored. It lives only in the URL fragment long
// enough to be exchanged at POST /session, then history.replaceState strips it.
// We keep only a non-sensitive session handle (org/project/expiry), in memory +
// sessionStorage, so a reload within the session TTL keeps the user signed in.

const KEY = 'luo-session-handle';

export function getSession(): SessionHandle | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const handle = JSON.parse(raw) as SessionHandle;
    if (new Date(handle.expiresAt).getTime() < Date.now()) {
      sessionStorage.removeItem(KEY);
      return null;
    }
    return handle;
  } catch {
    return null;
  }
}

export function setSession(handle: SessionHandle) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(handle));
  } catch {
    // ignore storage errors; in-memory is the fallback
  }
}

export function clearSession() {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
